export class ProjectAccordion {
    worklogs: [];
    isOpen: boolean;
}
